var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "importFromExpert",
    attrs: {
      id: "import-from-expert-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "md",
    },
    on: { show: _vm.handleShow, hide: _vm.handleHide },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("settings.accountTab.confirmPullingFromExpert")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("information-from-expert", { staticClass: "mb-2" }),
            _vm._v(" "),
            _vm.confirmPullingInfo || _vm.filogixDetails.hasImportCode
              ? _c(
                  "div",
                  [
                    _vm.showLoader
                      ? _c("import-from-expert-modal-loader", {
                          staticClass: "mb-4",
                        })
                      : _vm.missingFilogixDetailsForImport ||
                        _vm.invalidExpertProfileNumber
                      ? _c("missing-details-step", {
                          attrs: {
                            "filogix-details": _vm.filogixDetailsLocal,
                            "importing-clients": false,
                            "only-show-profile-number-field": "",
                          },
                          on: {
                            "update:filogixDetails": _vm.filogixDetailsChange,
                          },
                        })
                      : !_vm.isExpertNumberVerified ||
                        _vm.filogixDetails.hasImportCode
                      ? _c("verify-email-step", {
                          staticClass: "mb-2",
                          attrs: {
                            code: _vm.emailVerificationCode,
                            email: _vm.filogixDetails.hasImportCode
                              ? _vm.filogixDetails.lastVerificationEmail
                              : _vm.verificationEmail,
                          },
                          on: {
                            "update:code": _vm.updateEmailVerificationCode,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", {
              attrs: {
                text: _vm.btnText,
                loading: _vm.loading,
                "loading-succeeded": _vm.loadingSucceeded,
                disabled: _vm.$v.$invalid,
              },
              on: { click: _vm.handleImport },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }